// FUNCTIONS
async function ajaxRenderAuditions(page, pagination, scrollPosition, show, talent) {
	try {
		const formData = new FormData();
		let discipline;

		if (show == undefined) {
			show = 'any';
		}

		if (location.pathname.indexOf('headliner') != -1) {
			discipline = 'headliner';
		} else if (location.pathname.indexOf('livemusic') != -1) {
			discipline = 'livemusic';
		} else if (location.pathname.indexOf('productions') != -1) {
			discipline = 'productions';
		}

		formData.append('action', 'ajaxRenderAuditions');
		formData.append('discipline', discipline);
		formData.append('page', page);
		formData.append('pagination', pagination);
		formData.append('show', show);
		formData.append('talent', talent);

		const response = await fetch(adminAjax, {
			body: formData,
			method: 'POST'
		});

		if (!response.ok) {
			throw new Error('Failed to fetch auditions.');
		} else {
			const message = await response.json();

			document.querySelectorAll('.auditions .audition')?.forEach(el => el.remove());
			document.querySelector('.auditions .no-results-found')?.remove();

			if (show != 'All' || talent != 'All') {
				document.getElementById('audition-pagination')?.remove();

				if (paginationChangeInitialized) {
					paginationChangeInitialized = false;
				}
			}

			if (document.getElementById('audition-pagination')) {
				document.getElementById('audition-pagination').insertAdjacentHTML('beforebegin', message.data);
			} else {
				document.querySelector('.auditions').insertAdjacentHTML('beforeend', message.data);
			}

			document.querySelectorAll('.audition').forEach((element) => {
				fadeIn(element);
			});

			if (!paginationChangeInitialized && document.getElementById('audition-pagination') !== null) {
				paginationChangeInitialized = true;
			}

			if (scrollPosition) {
				document.getElementById('form-pos').scrollIntoView();
			} else {
				document.documentElement.scrollTop = 0
			}
		}
	} catch (error) {
		console.error(error);
		alert('Cannot connect to the server. Please try again later.');
	}
}

// VARIABLES
const auditions = document.querySelector('.auditions');

// INITIALIZATION
ajaxRenderAuditions(1, true, false, 'any', 'any');

// EVENT LISTENERS
auditions.addEventListener('change', (event) => {
	if (event.target.matches('#audition-pagination')) {
		const shows = document.getElementById('auditions-shows').value;
		const talents = document.getElementById('auditions-talents').value;

		ajaxRenderAuditions(event.target.value, true, true, shows, talents);
		document.getElementById('form-pos').scrollIntoView();
	}
});

document.addEventListener('DOMContentLoaded', () => {
	Fancybox.bind('[data-fancybox]', {});
});

document.querySelector('.upcoming-auditions-introduction .media-controls button')?.addEventListener('click', (event) => {
	event.preventDefault();

	const toggleState = event.currentTarget.querySelector('i');
	const video = document.getElementById('uaa-video');

	if (toggleState.classList.contains('icon-muted')) {
		toggleState.classList.replace('icon-muted', 'icon-volume');
	} else if (toggleState.classList.contains('icon-volume')) {
		toggleState.classList.replace('icon-volume', 'icon-muted');
	}

	video.muted = !video.muted;
});

document.querySelector('.upcoming-auditions-introduction .search').addEventListener('click', () => {
	const shows = document.getElementById('auditions-shows').value;
	const talents = document.getElementById('auditions-talents').value;

	ajaxRenderAuditions(1, true, true, shows, talents);
});